// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"383":"df15dc1a","786":"584d666a"}[chunkId] + ".css";
};